// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__2fGBq","footer":"ChangeClinic_footer__2Ez0E"};